const urlParams = new URLSearchParams(window.location.search);
const screenSize = urlParams.get("size") || "default";

const deviceLogicalPixelRatio = {
  "720": 0.666667,
  medium: 0.8,
  "1080": 1,
  "4k": 2,
  default: window.innerHeight / 1080
}[screenSize] || 1;

export default {
  // === Primary Brand ===
  primary: "#2C4F7C",         // Solid Blue
  primaryLight: "#4A7BD0",    // Lighter accent

  // === Neutrals ===
  backgroundDark: "#0E1218",
  surface: "#1A1F27",
  card: "#252C37",
  textPrimary: "#E6E8EB",
  textSecondary: "#7f848d",

  // === Accents ===
  success: "#4ADE80",
  warning: "#FBBF24",
  error: "#F87171",
  // focusGlow: "rgba(74, 123, 208, 0.6)",

  // === Gradients ===
  blueDepth: "linear-gradient(180deg, rgba(44,79,124,0.9), rgba(10,15,20,0.95))",
  midnightMist: "linear-gradient(180deg, #0E1218 0%, #1A1F27 100%)",

  // === Light Mode ===
  light: {
    background: "#F5F7FA",
    text: "#1E293B",
    surface: "#FFFFFF",
    accent: "#4A7BD0"
  },

  // === Dark Mode ===
  dark: {
    background: "#0E1218",
    text: "#E6E8EB",
    surface: "#1A1F27",
    accent: "#4A7BD0"
  },
  layout: {
    columnCount: 10,
    focusScale: 1.2,
    gutterX: 20,
    gutterY: 20,
    marginX: 150,
    marginY: 150,
    safe: 50,
    screenW: window.innerWidth / deviceLogicalPixelRatio,
    screenH: 1080
  },
  typography: {
    display1: {
      fontFamily: 'Arial',
      fontSize: 75,
      lineHeight: 85,
      fontWeight: 400,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    display2: {
      fontFamily: 'Arial',
      fontSize: 50,
      lineHeight: 60,
      fontWeight: 400,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    display3: {
      fontFamily: 'Arial',
      fontSize: 56,
      fontWeight: 400,
      lineHeight: 68,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    display4: {
      fontFamily: 'Arial',
      fontSize: 48,
      fontWeight: 400,
      lineHeight: 64,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    headline1: {
      fontFamily: 'Arial',
      fontSize: 35,
      fontWeight: 400,
      lineHeight: 48,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    headline2: {
      fontFamily: 'Arial',
      fontSize: 30,
      fontWeight: 400,
      lineHeight: 40,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    headline3: {
      fontFamily: 'Arial',
      fontSize: 25,
      fontWeight: 400,
      lineHeight: 36,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    body1: {
      fontFamily: 'Arial',
      fontSize: 25,
      fontWeight: 400,
      lineHeight: 40,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    body2: {
      fontFamily: 'Arial',
      fontSize: 22,
      fontWeight: 400,
      lineHeight: 32,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
    body3: {
      fontFamily: 'Arial',
      fontSize: 20,
      fontWeight: 400,
      lineHeight: 32,
      verticalAlign: 'middle',
      textBaseline: 'bottom'
    },
  },
  color: {
    palette: {},
    white: 0xffffffff,
    black: 0x000000ff,
    grey: 0x929096ff,
    red: 0xe74c3cff,
    orange: 0xdc7633ff,
    yellow: 0xf7dc6fff,
    green: 0x2ecc71ff,
    blue: 0x93a9fdff,
    purple: 0x663399ff,
    overlay: 0x181819b3,
    material: 0x181819ff,
    materialNeutral: 0x181819ff,
    materialNeutralElevated: 0x373639ff,
    materialInverse: 0xf8f7faff,
    materialInverseElevated: 0xffffffff,
    materialBrand: 0x000033ff,
    materialBrandElevated: 0x242a65ff,
    textNeutral: 0xf8f7faff,
    textNeutralSecondary: 0xf8f7fab3,
    textNeutralTertiary: 0xf8f7fa1a,
    textNeutralDisabled: 0xf8f7fa80,
    textInverse: 0x181819ff,
    textInverseSecondary: 0x181819b3,
    textInverseTertiary: 0x1818191a,
    textInverseDisabled: 0x18181980,
    textBrand: 0x93a9fdff,
    textBrandSecondary: 0x93a9fdb3,
    textBrandTertiary: 0x93a9fd1a,
    textBrandDisabled: 0x93a9fd80,
    textOnBrand: 0x181819ff,
    textOnBrandSecondary: 0x181819b3,
    textOnBrandTertiary: 0x1818191a,
    textOnBrandDisabled: 0x18181980,
    textPositive: 0x2ecc71ff,
    textNegative: 0xe74c3cff,
    textInfo: 0x93a9fdff,
    textCaution: 0xdc7633ff,
    fillTransparent: 0xffffff0,
    fillNeutral: 0xf8f7faff,
    fillNeutralSecondary: 0xf8f7fab3,
    fillNeutralTertiary: 0xf8f7fa1a,
    fillNeutralDisabled: 0xf8f7fa80,
    fillInverse: 0x181819ff,
    fillInverseSecondary: 0x181819b3,
    fillInverseTertiary: 0x1818191a,
    fillInverseDisabled: 0x18181980,
    fillBrand: 0x93a9fdff,
    fillBrandSecondary: 0x93a9fdb3,
    fillBrandTertiary: 0x93a9fd1a,
    fillBrandDisabled: 0x93a9fd80,
    fillPositive: 0x2ecc71ff,
    fillNegative: 0xe74c3cff,
    fillInfo: 0x93a9fdff,
    fillCaution: 0xdc7633ff,
    strokeNeutral: 0xf8f7faff,
    strokeNeutralSecondary: 0xf8f7fab3,
    strokeNeutralTertiary: 0xf8f7fa1a,
    strokeNeutralDisabled: 0xf8f7fa80,
    strokeInverse: 0x181819ff,
    strokeInverseSecondary: 0x181819b3,
    strokeInverseTertiary: 0x1818191a,
    strokeInverseDisabled: 0x18181980,
    strokeBrand: 0x93a9fdff,
    strokeBrandSecondary: 0x93a9fdb3,
    strokeBrandTertiary: 0x93a9fd1a,
    strokeBrandDisabled: 0x93a9fd80,
    strokeOnBrand: 0x181819ff,
    strokeOnBrandSecondary: 0x181819b3,
    strokeOnBrandTertiary: 0x1818191a,
    strokeOnBrandDisabled: 0x18181980,
    strokePositive: 0x2ecc71ff,
    strokeNegative: 0xe74c3cff,
    strokeInfo: 0x93a9fdff,
    strokeCaution: 0xdc7633ff,
    interactiveNeutral: 0xffffff1a,
    interactiveNeutralFocus: 0xffffffff,
    interactiveNeutralFocusSoft: 0xffffff1a,
    interactiveInverse: 0x48474b1a,
    interactiveInverseFocus: 0x48474bff,
    interactiveInverseFocusSoft: 0x48474b1a,
    interactiveBrand: 0xbecffe1a,
    interactiveBrandFocus: 0xbecffeff,
    interactiveBrandFocusSoft: 0xbecffe1a,
    shadowDefault: 0x000000b3,
    shadowFocused: 0x0000001a,
    shadowElevated: 0x000000b3,
    shadowText: 0x000000b3,
    shadowNeutral: 0x000000b3,
    shadowNeutralFocus: 0x000000b3,
    shadowNeutralElevated: 0x000000b3,
    shadowNeutralText: 0x0000000,
    shadowInverse: 0x000000b3,
    shadowInverseFocus: 0x000000b3,
    shadowInverseElevated: 0x000000b3,
    shadowInverseText: 0x0000000,
    shadowBrand: 0x000000b3,
    shadowBrandFocus: 0x000000b3,
    shadowBrandElevated: 0x000000b3,
    shadowBrandText: 0x0000000
  },
}
